<ng-container *ngIf="!online">
  <ion-icon class="vertical-middle font-18" name="cloud-offline" color="danger" (click)="presentPopover()"></ion-icon>&nbsp;
</ng-container>